import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

import Vue, {
  onMounted,
  ref,
  watch,
  defineAsyncComponent,
  onBeforeUnmount,
  computed,
} from "vue";
import {
  admDateList,
  configAdmList,
  admDateListAdUnit,
  h5AdmDateList,
  h5AdmDateListAdUnit,
} from "@/api/api";
import XDialog from "@/components/XDialog.vue";
import { notification } from "ant-design-vue";
import { onBeforeRouteLeave } from "vue-router";
import { useStore } from "vuex";
import dayjs, { Dayjs } from "dayjs";


export default /*#__PURE__*/_defineComponent({
  __name: 'H5Ads',
  props: {
    appData: {},
    dateTime: {},
    isRefresh: { type: Boolean },
    dbName: {}
  },
  setup(__props: any) {

const XATable = defineAsyncComponent(() => import("../components/XATable.vue"));
const store = useStore();
const props = __props;
const currentAppId = ref("");
const rightAppIdVal = ref<any[]>([]);
var appIdList: any[] = [];
const maxTagCount = ref(1);
const checkedValue = ref(true);
const configList = ref([
  { type: 1, appName: "火山开发者" },
  { type: 2, appName: "玫瑰开发者" },
]);
const dateValue = ref("");
const pageNo = ref(1);
const activeKey = ref(-1);
const detailVisible = ref(false);
const detailLoading = ref(false);
const adsTitle = ref("详情");
const curDetailRow = ref<any>({});

const columns = ref([
  { title: "Date", key: "day", dataIndex: "day" },
  //   { title: "ID", key: "id", dataIndex: "id" },
  //   { title: "Remark", key: "scene", dataIndex: "scene" },
  { title: "*Page View", key: "pageView", dataIndex: "pageView" },
  {
    title: "*Page RPM",
    key: "pageRpm",
    dataIndex: "pageRpm",
    slots: { customRender: "pageRpm" },
  },
  { title: "Request", key: "adRequest", dataIndex: "adRequest" },
  { title: "Show", key: "adShowCount", dataIndex: "adShowCount" },
  { title: "Clicks", key: "adClickCount", dataIndex: "adClickCount" },
  {
    title: "Match Rate",
    key: "coverRate",
    dataIndex: "coverRate",
    slots: { customRender: "coverRate" },
  },
  {
    title: "Show Rate",
    key: "showRate",
    dataIndex: "showRate",
    slots: { customRender: "showRate" },
  },
  {
    title: "CTR",
    key: "ctr",
    dataIndex: "ctr",
    slots: { customRender: "ctr" },
  },
  {
    title: "CPC",
    key: "cpc",
    dataIndex: "cpc",
    slots: { customRender: "cpc" },
  },
  {
    title: "*Revenue",
    key: "income",
    dataIndex: "income",
    slots: { customRender: "income" },
  },
  {
    title: "控制",
    key: "control",
    dataIndex: "control",
    slots: { customRender: "control" },
  },
]);
const detailColumns = ref([
//   { title: "Date", key: "day", dataIndex: "day" },
  { title: "ID", key: "projectId", dataIndex: "projectId" },
  { title: "*Page View", key: "pageView", dataIndex: "pageView" },
  {
    title: "*Page RPM",
    key: "pageRpm",
    dataIndex: "pageRpm",
    slots: { customRender: "pageRpm" },
  },
  { title: "Request", key: "adRequest", dataIndex: "adRequest" },
  { title: "Show", key: "adShowCount", dataIndex: "adShowCount" },
  { title: "Clicks", key: "adClickCount", dataIndex: "adClickCount" },
  {
    title: "Match Rate",
    key: "coverRate",
    dataIndex: "coverRate",
    slots: { customRender: "coverRate" },
  },
  {
    title: "Show Rate",
    key: "showRate",
    dataIndex: "showRate",
    slots: { customRender: "showRate" },
  },
  {
    title: "CTR",
    key: "ctr",
    dataIndex: "ctr",
    slots: { customRender: "ctr" },
  },
  {
    title: "CPC",
    key: "cpc",
    dataIndex: "cpc",
    slots: { customRender: "cpc" },
  },
  {
    title: "*Revenue",
    key: "income",
    dataIndex: "income",
    slots: { customRender: "income" },
  },
  { title: "Remark", key: "scene", dataIndex: "scene" },
]);
const tableData = ref([]);
const detailTableData = ref([]);
const loading = ref(false);
let timerInval = ref();
var BackOrderIds: any[] = [];

const getRequestData = () => {
  loading.value = true;
  const params: any = {
    beginTime: dayjs(dateValue.value[0]).format("YYYY-MM-DD"),
    endTime: dayjs(dateValue.value[1]).format("YYYY-MM-DD"),
  };
  if (activeKey.value !== -1) {
    params.type = activeKey.value;
  }
  h5AdmDateList(params).then((res) => {
    loading.value = false;
    res.data.forEach((element: any) => {
      if (!element.date) {
        element.date = "汇总";
      }
    });
    tableData.value = res.data;
  });
};
// 监听 Vuex 的 refreshNeeded 状态
const refreshNeeded = computed(() => store.state.refundRefreshNeeded);

// 监控 refreshNeeded 的变化
watch(refreshNeeded, (newValue) => {
  console.log("123123", newValue);
  if (newValue) {
    // 执行页面刷新操作
    getRequestData();
    // 重置刷新状态
    store.dispatch("resetRefundRefresh");
  }
});

watch(
  () => props.isRefresh,
  (cur, old) => {
    getRequestData();
  }
);

watch(
  () => props.dateTime,
  (cur, old) => {
    console.log(cur);
    dateValue.value = cur;
    getRequestData();
  },
  {
    immediate: true,
  }
);

const tabClick = (tabIndex: any) => {
  activeKey.value = tabIndex;
  getRequestData();
};
const pageChange = (page: any) => {
  pageNo.value = page;
  getRequestData();
};
const getConfigList = () => {
  configAdmList({}).then((res) => {
    console.log(res);
    configList.value = res.data;
  });
};
const confirmDetail = (row: any) => {
  console.log(row);
  curDetailRow.value = row;
  adsTitle.value = "详情" + "(" + row.day + ")";
  detailVisible.value = true;
  detailLoading.value = true;
  var beginTime = row.date;
  var endTime = row.date;
  if (row.date === "汇总") {
    beginTime = dayjs(dateValue.value[0]).format("YYYY-MM-DD");
    endTime = dayjs(dateValue.value[1]).format("YYYY-MM-DD");
  }
  var params = {
    appId: row.appId,
    beginTime: row.day,
    endTime: row.day,
  };
  if (activeKey.value === 1) {
    params.type = 1;
  } else if (activeKey.value === 2) {
    params.type = 2;
  }
  h5AdmDateListAdUnit(params).then((res) => {
    detailLoading.value = false;
    detailTableData.value = res.data;
  });
};
onMounted(() => {
  checkedValue.value = store.state.refundCheckedValue;
  dateValue.value = props.dateTime;
  //   getConfigList();
  getRequestData();
});
const toFixedDown = (num: any, digits: any) => {
  const factor = Math.pow(10, digits);
  return Math.floor(num * factor) / factor;
};

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_tabs, {
      activeKey: activeKey.value,
      "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((activeKey).value = $event)),
      onTabClick: tabClick
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_a_tab_pane, {
          key: -1,
          tab: "全部"
        })),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configList.value, (item, index) => {
          return (_openBlock(), _createBlock(_component_a_tab_pane, {
            key: item.type,
            tab: item.appName,
            disabled: loading.value
          }, null, 8, ["tab", "disabled"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["activeKey"]),
    _createVNode(_unref(XATable), {
      columns: columns.value,
      dataSource: tableData.value,
      scroll: { x: 1500 },
      loading: loading.value
    }, {
      coverRate: _withCtx(({ scope }) => [
        _createElementVNode("span", null, _toDisplayString(scope.record.coverRate.toFixed(2)) + "%", 1)
      ]),
      showRate: _withCtx(({ scope }) => [
        _createElementVNode("span", null, _toDisplayString(scope.record.showRate.toFixed(2)) + "%", 1)
      ]),
      estimatedEarnings: _withCtx(({ scope }) => [
        _createElementVNode("span", null, "$" + _toDisplayString(scope.record.estimatedEarnings.toFixed(2)), 1)
      ]),
      observedEcpm: _withCtx(({ scope }) => [
        _createElementVNode("span", null, "$" + _toDisplayString(scope.record.observedEcpm.toFixed(2)), 1)
      ]),
      ctr: _withCtx(({ scope }) => [
        _createElementVNode("span", null, _toDisplayString(scope.record.ctr.toFixed(2)), 1)
      ]),
      matchRate: _withCtx(({ scope }) => [
        _createElementVNode("span", null, _toDisplayString(scope.record.matchRate.toFixed(2)) + "%", 1)
      ]),
      cpc: _withCtx(({ scope }) => [
        _createElementVNode("span", null, _toDisplayString(toFixedDown(scope.record.cpc, 3)), 1)
      ]),
      income: _withCtx(({ scope }) => [
        _createElementVNode("span", null, "$" + _toDisplayString(toFixedDown(scope.record.income, 2)), 1)
      ]),
      pageRpm: _withCtx(({ scope }) => [
        _createElementVNode("span", null, _toDisplayString(toFixedDown(scope.record.pageRpm, 2)), 1)
      ]),
      control: _withCtx(({ scope }) => [
        (tableData.value.indexOf(scope.record) !== 0)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              type: "link",
              onClick: ($event: any) => (confirmDetail(scope.record))
            }, {
              default: _withCtx(() => [
                _createTextVNode("详情")
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "dataSource", "loading"]),
    _createVNode(XDialog, {
      visible: detailVisible.value,
      title: adsTitle.value,
      xWidth: "100%",
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (detailVisible.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(XATable), {
          columns: detailColumns.value,
          dataSource: detailTableData.value,
          scroll: { x: 1500 },
          loading: detailLoading.value
        }, {
          coverRate: _withCtx(({ scope }) => [
            _createElementVNode("span", null, _toDisplayString(scope.record.coverRate.toFixed(2)) + "%", 1)
          ]),
          showRate: _withCtx(({ scope }) => [
            _createElementVNode("span", null, _toDisplayString(scope.record.showRate.toFixed(2)) + "%", 1)
          ]),
          estimatedEarnings: _withCtx(({ scope }) => [
            _createElementVNode("span", null, "$" + _toDisplayString(scope.record.estimatedEarnings.toFixed(2)), 1)
          ]),
          observedEcpm: _withCtx(({ scope }) => [
            _createElementVNode("span", null, "$" + _toDisplayString(scope.record.observedEcpm.toFixed(2)), 1)
          ]),
          ctr: _withCtx(({ scope }) => [
            _createElementVNode("span", null, _toDisplayString(scope.record.ctr.toFixed(2)), 1)
          ]),
          matchRate: _withCtx(({ scope }) => [
            _createElementVNode("span", null, _toDisplayString(scope.record.matchRate.toFixed(2)) + "%", 1)
          ]),
          cpc: _withCtx(({ scope }) => [
            _createElementVNode("span", null, _toDisplayString(toFixedDown(scope.record.cpc, 3)), 1)
          ]),
          income: _withCtx(({ scope }) => [
            _createElementVNode("span", null, "$" + _toDisplayString(toFixedDown(scope.record.income, 2)), 1)
          ]),
          pageRpm: _withCtx(({ scope }) => [
            _createElementVNode("span", null, _toDisplayString(toFixedDown(scope.record.pageRpm, 2)), 1)
          ]),
          _: 1
        }, 8, ["columns", "dataSource", "loading"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ], 64))
}
}

})